module.exports = __webpack_public_path__ + "media/promo/courses/images/ic-3-5bc7f1b9572ef33ca45528ce33557fcc.png";